import { jsx as _jsx } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import Close from '@hellodarwin/icons/dist/icons/Close';
import ProjectsList from '@hellodarwin/icons/dist/icons/ProjectsList';
import { useTheme } from 'styled-components';
const AssistantDrawerButton = ({ handleDrawer, open, }) => {
    const theme = useTheme();
    return (_jsx(Button, { onClick: handleDrawer, size: "circle", transparent: open, headingIcon: open ? _jsx(Close, { size: 16 }) : _jsx(ProjectsList, { size: 16 }), defaultStyle: theme.colors.grey_1, style: {
            flexShrink: 0,
            width: theme.spacing.xl,
        } }));
};
export default AssistantDrawerButton;
